import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { Icon } from "../../../themes/userq/Icon/Icon";
import { Text } from "../../../themes/userq/Text/Text";

export default function PreviewPrototype({
    open,
    prototype_link,
    device,
    rtl,
    close,
}) {
    const iframeRef = useRef(null);
    const wrapperRef = useRef(null);

    const closeModal = () => {
        close();
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target) &&
                event.target.nodeName === "DIV"
            ) {
                closeModal();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const maximizeIframe = () => {
        if (iframeRef.current) {
            if (iframeRef.current.requestFullscreen) {
                iframeRef.current.requestFullscreen();
            } else if (iframeRef.current.mozRequestFullScreen) {
                iframeRef.current.mozRequestFullScreen();
            } else if (iframeRef.current.webkitRequestFullscreen) {
                iframeRef.current.webkitRequestFullscreen();
            } else if (iframeRef.current.msRequestFullscreen) {
                iframeRef.current.msRequestFullscreen();
            }
        }
    };

    return (
        <Modal
            show={open}
            centered
            className={`fade custom-modal-wrap ${device && device === "mobile" ? "mobile-iframe-wrapper" : ""
                } ${rtl ? "arabic-wrapper" : ""} confirmation-modal-wrap goal-screen-modal-wrap`}
            onHide={closeModal}
        >
            <Modal.Body ref={wrapperRef}>
                <div className="modal-inner-text">
                    <div className="modal-header-top">
                        <Text type="h3">Preview Prototype</Text>

                        <button
                            type="button"
                            className="close"
                            onClick={closeModal}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">
                                <Icon value="Close" size="medium" hover={true} />
                            </span>
                        </button>
                    </div>
                    <div className="iframewrap-max-height">
                        <iframe
                            ref={iframeRef}
                            id="figma_prototype_iframe"
                            height="450"
                            width="800"
                            src={prototype_link}
                            allowFullScreen
                        />

                        <div
                            onClick={maximizeIframe}
                            className="figma-prototype-controls figma-prototype-control-maximize"
                        >
                            <Icon value="maximize" size="medium" />
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
